const TAG_REGEXP = /<[^>]+>/g;

/**
 * Removes any HTML tags from the given string.
 * @param value the string containing HTML tags
 * @returns the string with the removed html tags.
 */
export function stripTags(value: string) {
	return value.replace(TAG_REGEXP, '');
}
